import { render, staticRenderFns } from "./EmployeesUpdate.vue?vue&type=template&id=38cb1fd6&scoped=true"
import script from "./EmployeesUpdate.vue?vue&type=script&lang=js"
export * from "./EmployeesUpdate.vue?vue&type=script&lang=js"
import style0 from "./EmployeesUpdate.vue?vue&type=style&index=0&id=38cb1fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb1fd6",
  null
  
)

export default component.exports